export default (currentValue, maxValue) => {
  if (typeof maxValue !== "number" || typeof currentValue !== "number") {
    return false;
  }
  return currentValue <= maxValue;
};
